import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Card } from '../ui/Card';
interface AttentionCardProps {
  studentName: string;
  weakestSubject: string;
  mastery: number;
  pedagogicalHint?: string;
}
export function AttentionCard({
  studentName,
  weakestSubject,
  mastery,
  pedagogicalHint
}: AttentionCardProps) {
  return <Card className="p-4 border-rose-200 bg-rose-50/50 hover:bg-rose-50 transition-colors" data-id="element-5018">
      <div className="flex items-start gap-3" data-id="element-5019">
        <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center text-rose-600 font-bold flex-shrink-0" data-id="element-5020">
          {studentName.charAt(0).toUpperCase()}
        </div>
        <div className="flex-1 min-w-0" data-id="element-5021">
          <div className="flex items-center justify-between mb-1" data-id="element-5022">
            <h4 className="font-bold text-slate-900 truncate" data-id="element-5023">{studentName}</h4>
            <span className="text-xs font-black text-rose-600 bg-rose-100 px-2 py-0.5 rounded-full" data-id="element-5024">
              {mastery}%
            </span>
          </div>
          <p className="text-sm text-slate-600 flex items-center gap-1.5 mb-1.5" data-id="element-5025">
            <AlertTriangle className="w-3.5 h-3.5 text-amber-500" data-id="element-5026" />
            Moeite met{' '}
            <span className="font-semibold text-slate-800" data-id="element-5027">
              {weakestSubject}
            </span>
          </p>
          {pedagogicalHint && <p className="text-xs text-rose-700 bg-rose-100/50 p-2 rounded-lg border border-rose-100" data-id="element-5028">
              <span className="font-bold" data-id="element-5029">Tip:</span> Extra aandacht voor{' '}
              {pedagogicalHint}
            </p>}
        </div>
      </div>
    </Card>;
}